export default __webpack_public_path__ + "static/media/bag.c58d2d5d.svg";